import functions from "../../../../../world/spa/libs/vuexFunctions";

export default {
  namespaced: true,
  state: {
    objs: []
  },
  getters: {
    ...functions.createDefaultGetters(),
    getByWork: state => workId => {
      return state.objs.filter(wp => wp.work === workId);
    },
    getByPlace: state => placeId => {
      return state.objs.filter(wp => wp.place === placeId);
    }
  },
  mutations: {
    ...functions.createDefaultMutations()
  },
  actions: {
    ...functions.createDefaultActionsWithStore()
  },
}